// Your own name and Venmo handle, remembered on this device across receipts:
// saved when you leave the first mates-table row ("Me"), and used to prefill
// that row on every new check (and the guest "Who are you?" form).
const NAME_KEY = "checkmates.myName";
const VENMO_KEY = "checkmates.myVenmo";

function read(key: string): string {
  try {
    return localStorage.getItem(key) ?? "";
  } catch {
    return "";
  }
}

function write(key: string, value: string): void {
  try {
    const v = value.trim();
    if (v) localStorage.setItem(key, v);
    else localStorage.removeItem(key);
  } catch {
    // storage unavailable — ignore
  }
}

export const getMyName = () => read(NAME_KEY);
export const setMyName = (name: string) => write(NAME_KEY, name);
export const getMyVenmo = () => read(VENMO_KEY);
export const setMyVenmo = (venmo: string) => write(VENMO_KEY, venmo);
